export default __webpack_public_path__ + "media/zurb/img/ecommerce/shopping_flow7-7dbe849573476cdaa2ae65f4b1e24172.png";